
import Swal from "sweetalert2";
import { Component, Vue, Watch } from "vue-property-decorator";
import { D3SlicesChart } from "vue-d3-charts";
import Chart from "chart.js";
import AfiliadoService from "@/services/AfiliadoService";
import { DashboardTrimestralResponse } from "@/models/Dashboard/DashboardTrimestralResponse";
import { BeneficiosDisponiblesResponse } from "@/models/Dashboard/BeneficiosDisponiblesResponse";
import { VideoIntroResponse } from "@/models/Dashboard/VideoIntroResponse";
import {
  DashboardEntity,
  DashboardResponse,
} from "@/models/Dashboard/DashboardResponse";
import axios, { AxiosResponse } from "axios";
import Beneficios from "@/components/Beneficios.vue";
import DoughnutChart from "@/components/Doughnut.vue";
import ChartDataLabels from "chartjs-plugin-datalabels";
import User from "@/models/User";
import { Getter } from "vuex-class";
@Component({ components: { D3SlicesChart, Beneficios, DoughnutChart } })
export default class DashBoard extends Vue {
  public afiliadoService: AfiliadoService = new AfiliadoService();
  public show: boolean = false;
  public validarBeneficios: boolean = false;
  public DashBoard: DashboardEntity | null = null;
  public DashBoardTrimestral: DashboardTrimestralResponse =
    new DashboardTrimestralResponse();
  public BeneficiosDisponibles: BeneficiosDisponiblesResponse =
    new BeneficiosDisponiblesResponse();
  public VideoIntroResponse: VideoIntroResponse = new VideoIntroResponse();
  public LineChartLabels: string[] = [];
  public LineChartValues: number[] = [];
  public userId: string = this.$store.state.user.cedula;
  @Getter("user") user: User;

  public async getTrimestral(): Promise<any> {
    try {
      const user = this.$store.state.user;
      const response = await this.afiliadoService.getDashbordTrimestral(
        user.cedula,
        user.TokenGenerate,
        user.userIdentityEncrypt
      );

      const payload = response.data.payload;
      if (payload && payload.data && Array.isArray(payload.data)) {
        const data = payload.data;
        data.forEach((item) => {
          item.secuencia = item.secuencia;
        });

        data.sort((a, b) => a.secuencia - b.secuencia);

        for (let i = 0; i < data.length; i++) {
          this.LineChartLabels[i] = data[i].nombrePeriodo;
          this.LineChartValues[i] = data[i].monto;
        }

        this.DashBoardTrimestral = { data: data };
      }
    } catch (error) {
      console.error("Error obteniendo balance trimestral:", error);
      this.DashBoardTrimestral = null;
    }
  }

  public async getDashboard(): Promise<void> {
    const user = this.$store.state.user;

    try {
      const response = await this.afiliadoService.getDashboardNew(
        user.cedula,
        user.TokenGenerate,
        user.userIdentityEncrypt
      );

      const payload = response.data.payload;

      if (!user.esAfiliado) {
        this.goSolicitudesBeneicios();
        return;
      }

      this.DashBoard = payload.entity;
      this.show = true;
    } catch (error) {
      console.error("Error al obtener el dashboard:", error);
      this.show = false;
    }
  }

  public async getData() {
    this.openLoader();
    await this.afiliadoService
      .getVideoIntro(this.userId)
      .then((resp) => {
        this.VideoIntroResponse = resp.data;
        this.show = true;
      })
      .catch((error) => {
        console.log(error);
      });

    const statusesPromise = Promise.allSettled([
      this.getTrimestral(),
      this.getDashboard(),
      this.getBeneficiosDisponibles(),
    ]);
    const [trimestral, dashboard, benefDisponibles] = await statusesPromise;
    // var responseTrimestral = await this.afiliadoService
    //   .getDashbordTrimestral(this.userId)
    //   .then((response) => {
    //     if (response.data.data != null) {
    //       response.data.data = response.data.data.sort( (a, b) => {
    //         return parseFloat(a.secuencia) - parseFloat(b.secuencia);
    //       });
    //
    //       for (let i = 0; i < response.data.data.length; i++) {
    //         this.LineChartLabels[i] = response.data.data[i].nombrePeriodo;
    //         this.LineChartValues[i] = response.data.data[i].monto;
    //       }
    //     }
    //     this.DashBoardTrimestral = response.data;
    //   })
    //   .catch((error) => {
    //     return error;
    //   });
    // var response = await this.afiliadoService
    //   .getDashbord(this.userId)
    //   .then((resp) => {
    //     this.DashBoard = resp.data;
    //     this.show = true;
    //   })
    //   .catch((error) => {
    //     return error;
    //   });

    // await this.afiliadoService
    //   .getBeneficiosDisponibles(this.userId)
    //   .then((resp) => {
    //     this.BeneficiosDisponibles = resp.data;
    //     this.show = true;
    //   })
    //   .catch((error) => {
    //     return error;
    //   });

    this.$forceUpdate();

    this.closeLoader();
  }
  public async getBeneficiosDisponibles(): Promise<any> {
    var response = await this.afiliadoService
      .getBeneficiosDisponibles(this.userId)
      .then((resp) => {
        this.BeneficiosDisponibles = resp.data;
        this.show = true;
      })
      .catch((error) => {
        return error;
      });
    return response;
  }
  async created() {
    try {
      await this.getData();
    } catch (error) {
      console.error("Error en getData:", error);
    }
    try {
      this.goIntro();
    } catch (error) {
      console.error("Error en goIntro:", error);
    }

    if (true) {
      const canvas = document.getElementById("myChart");
      const canvasElement = canvas as HTMLCanvasElement;
      const ctx = canvasElement.getContext("2d");

      Chart.helpers.merge(Chart.defaults.global.plugins.datalabels, {
        color: "#FE777B",
      });
      const myChart = new Chart(ctx, {
        type: "doughnut",
        data: {
          labels: [
            "Tus Aportes",
            "Aportes de tu Empleador",
            "Rentabilidad Acreditada",
            "Otros Aportes",
          ],
          datasets: [
            {
              data: [
                Number(
                  this.DashBoard.dashboard.distribucionBalanceMonto.aporteEmpleado.toFixed(
                    2
                  )
                ),
                Number(
                  this.DashBoard.dashboard.distribucionBalanceMonto.aporteEmpleador.toFixed(
                    2
                  )
                ),
                Number(
                  this.DashBoard.dashboard.distribucionBalanceMonto.rentabilidad.toFixed(
                    2
                  )
                ),
                Number(
                  this.DashBoard.dashboard.distribucionBalanceMonto.otrosAportes.toFixed(
                    2
                  )
                ),
              ],
              backgroundColor: ["#F8B822", "#005EB8", "#F57034", "#8FCBFC"],
              hoverBackgroundColor: [
                "#F8B822",
                "#005EB8",
                "#F57034",
                "#8FCBFC",
              ],
            },
          ],
        },
        plugins: [ChartDataLabels],
        options: {
          tooltips: {
            enabled: true,
            callbacks: {
              label: function (tooltipItem, data) {
                var dataset = data.datasets[tooltipItem.datasetIndex];
                //  var total = dataset.data.reduce(function(previousValue, currentValue, currentIndex, array) {
                //    return previousValue + currentValue;
                //  });
                let total = 0 as number;
                for (const n of dataset.data) total += Number(n);
                var currentValue: any = dataset.data[tooltipItem.index];
                //var precentage = Math.floor((((currentValue/total) * 100)+0.5));
                var precentage = (currentValue / total) * 100;
                var formatted = currentValue
                  .toFixed(2)
                  .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                return data.labels[tooltipItem.index] + " : " + formatted;
              },
            },
          },
          responsive: true,
          maintainAspectRatio: false,
          plugins: {
            datalabels: {
              color: "#FFFFFF",
              font: {
                family: "EvaPro",
                size: 18,
              },
              formatter: function (value, ctx) {
                const datapoints = ctx.chart.data.datasets[0].data;
                //const total = datapoints.reduce((total, datapoint) => total + datapoint, 0);
                let total = 0 as number;
                for (const n of datapoints) total += Number(n);
                const percentage = (value / total) * 100;
                if (percentage < 5.9) {
                  return "";
                }
                return percentage.toFixed(2) + "%";
              },
            },
          },
          legend: {
            display: false,
          },
        },
      });
    }

    const canvas2 = document.getElementById("TableChart");
    const canvasElement2 = canvas2 as HTMLCanvasElement;
    const ctx2 = canvasElement2.getContext("2d");
    this.DashBoardTrimestral.data = this.DashBoardTrimestral.data.sort(
      function (a, b) {
        return a.secuencia - b.secuencia;
      }
    );
    // const ctx2 = document.getElementById("TableChart").getContext("2d");
    const TableChart = new Chart(ctx2, {
      type: "line",
      data: {
        labels: this.LineChartLabels,
        datasets: [
          {
            data: [
              Number(this.LineChartValues[0]?.toFixed(2)),
              Number(this.LineChartValues[1]?.toFixed(2)),
              Number(this.LineChartValues[2]?.toFixed(2)),
              Number(this.LineChartValues[3]?.toFixed(2)),
              Number(this.LineChartValues[4]?.toFixed(2)),
            ],
            fill: false,
            backgroundColor: [
              "rgba(200, 0, 0, 0)",
              "rgba(200, 0, 0, 0)",
              "rgba(200, 0, 0, 0)",
              "rgba(200, 0, 0, 0)",
              "rgba(200, 0, 0, 0)",
              "rgba(0, 0, 0, 0)",
            ],
            borderColor: "#0E66B9",
            pointBackgroundColor: [
              "white",
              "white",
              "white",
              "white",
              "white",
              "white",
              "white",
            ],
            pointBorderColor: [
              "#F3A13A",
              "#F3A13A",
              "#F3A13A",
              "#F3A13A",
              "#F3A13A",
              "#F3A13A",
              "#F3A13A",
            ],
            borderWidth: 3,
            pointRadius: 5,
          },
        ],
      },
      options: {
        tooltips: {
          enabled: true,
          callbacks: {
            label: function (tooltipItem, data) {
              var dataset = data.datasets[tooltipItem.datasetIndex];

              var currentValue: any = dataset.data[tooltipItem.index];

              return currentValue
                .toString()
                .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
            },
          },
        },
        scales: {
          yAxes: [
            {
              ticks: {
                callback: function (value, index, ticks) {
                  return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                },

                padding: 20,
                //crossAlign: 'start',
              },
              offset: true,
              gridLines: {
                display: true,
              },
            },
          ],
          xAxes: [
            {
              gridLines: {
                display: false,
              },
            },
          ],
        },
        plugins: {
          title: {
            display: false,
          },
        },
        legend: {
          display: false,
        },
      },
    });
  }

  get isDashboardDataAvaliable() {
    return (
      this.DashBoard != null && this.DashBoard.userIdentity != null // o cualquier validación más adecuada
    );
  }
  ///
  public goSolicitudesBeneicios() {
    this.$router.push("/solicitudes-beneficiario").catch(() => {});
  }

  public goIntro() {
    this.DashBoard.dashboard.indMostrarVideo = 1; //Temporal
    if (
      this.isDashboardDataAvaliable &&
      this.DashBoard.dashboard.indMostrarVideo == 0
    ) {
      this.$router.push("/TourVirtual");
    }
  }
  public numberWithCommas(x) {
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  }
  public consultarBeneficios() {
    this.validarBeneficios = true;
  }

  public openLoader() {
    Swal.fire({
      title: "Cargando",
      html: " ",
      timerProgressBar: true,
      onOpen: () => {
        Swal.showLoading();
      },
    });
  }
  public closeLoader() {
    Swal.close();
  }
}
